import React, { useState } from "react";
import { Button, Card, Image, Typography } from "antd";
const { Title } = Typography;
import { CloudDownloadOutlined } from "@ant-design/icons";
type DownloadPageProps = {
  hideFrame?: boolean;
};
export const DownloadPage = (props: DownloadPageProps) => {
  const [downloadStarted, setDownloadStarted] = useState(false);
  const downloadLauncher = () => {
    const a = document.createElement("a");
    a.href = "https://app.herozonevr.com/latest";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setDownloadStarted(true);
    setTimeout(() => {
      setDownloadStarted(false);
    }, 3000);
  };
  const renderButton = () => {
    return (
      <Button
        disabled={downloadStarted}
        loading={downloadStarted}
        icon={
          downloadStarted ? undefined : (
            <CloudDownloadOutlined style={{ fontSize: 20 }} />
          )
        }
        className="cta-button cta-button-lg"
        style={{
          marginTop: 12,
          width: "100%",
          maxWidth: 360,
        }}
        size="large"
        type="primary"
        onClick={downloadLauncher}
      >
        {downloadStarted
          ? "Download In Progress"
          : "Download Hero Zone Launcher"}
      </Button>
    );
  };
  return (
    <Card
      style={
        props.hideFrame
          ? {
              background: "none",
              border: "none",
            }
          : {}
      }
      bodyStyle={props.hideFrame ? { padding: 0 } : undefined}
    >
      <div className="download-page-inner">
        <div className="download-page-text">
          <Title level={1}> Get Started With Hero Zone</Title>
          <p style={{ fontSize: 18 }}>
            Dive Into the Ultimate VR Gaming Experience
          </p>
          {renderButton()}
        </div>

        <Image
          src="/images/launcher.jpg"
          preview={false}
          className="download-page-image"
          style={{ userSelect: "none" }}
        />
      </div>
    </Card>
  );
};
